// Animal types
const VACA = "vaca";
const FRISON = "frison";
const VACUNO = "bovine";
const MONTBELIARD_SIMMENTAL_ETC = "montbeliard,simmental...";
const CRUZADO_1 = "cruzado 1";
const CRUZADO_2 = "cruzado 2";
const SELECTO = "selecto";
// Sex types
const MACHO = "male";
const HEMBRA = "female";
// People types
const COMERCIALIZADOR = "comercializador";
const PRODUCTOR = "productor";
// Keys
const VACUNO_MACHO_KEY = "bovineMale";
const VACUNO_HEMBRA_KEY = "bovineFemale";
const FRISON_MACHO_KEY = "frison";
const VACA_KEY = "vaca";

const Animals = {
  bovineMale: {
    type: VACUNO,
    sex: MACHO,
    name: "Bovino Machos",
    weight: {
      1: "<280KG",
      2: "281/320KG",
      3: "321/370KG",
      4: ">371KG",
    },
    fatType: {
      1: "E",
      2: "U",
      3: "R",
      4: "O",
    },
  },
  frison: {
    sex: MACHO,
    type: FRISON,
    name: "Frisones",
    weight: {
      1: "<220KG",
      2: ">220KG",
    },
    fatType: {
      1: "O",
    },
  },
  bovineFemale: {
    sex: HEMBRA,
    type: VACUNO,
    name: "Bovino Hembras",
    weight: {
      1: "180/220KG",
      2: "221/260KG",
      3: "261/300KG",
      4: ">300KG",
    },
    fatType: {
      1: "E",
      2: "U",
      3: "R",
      4: "O",
    },
  },
  vaca: {
    sex: HEMBRA,
    type: VACA,
    name: "Vacas",
    weight: {
      200: "200KG",
      220: "220KG",
      240: "240KG",
      260: "260KG",
      280: "280KG",
      300: "300KG",
      320: "320KG",
      340: "340KG",
      360: "360KG",
      380: "380KG",
      400: "400KG",
      420: "420KG",
    },
    fatType: {
      1: "U3/R3-O2/O3",
      2: "R1/O1",
      3: "P1/P2",
    },
  },
};

//
const HIGHLIGHT_PROJECT_ID = process.env.REACT_APP_HIGHLIGHT_PROJECT_ID;

export {
  Animals,
  COMERCIALIZADOR,
  CRUZADO_1,
  CRUZADO_2,
  FRISON,
  FRISON_MACHO_KEY,
  HEMBRA,
  MACHO,
  MONTBELIARD_SIMMENTAL_ETC,
  PRODUCTOR,
  SELECTO,
  VACA,
  VACA_KEY,
  VACUNO,
  VACUNO_HEMBRA_KEY,
  VACUNO_MACHO_KEY,
  HIGHLIGHT_PROJECT_ID,
};
